const tabcordion = {

	element: document.querySelectorAll('.tabcordion'),
	
	mql: {
		large: window.matchMedia('(min-width: 1024px)')
	},
	
	init() {
		if (tabcordion.element.length > 0) {
			this.reset();
		}
	},

	// If large or larger, destroy all existing tabs and create an accordion
	// If medium or smaller, destroy all existing toggles and create tabs
	reset() {
		if(tabcordion.mql.large.matches) {
			document.querySelectorAll('.tabcordion .br-tabs').forEach( function( element ) {
				element.tab = Object.assign(new BRTabs(element, { open: 0 }));
			});
		} else {
			document.querySelectorAll('.tabcordion .br-toggle').forEach( function( element ) {
				element.toggle = Object.assign(new BRToggle(element, { accordion: true }));
			});
		}
	}
	
};

export { tabcordion };
